import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";

export const TableFormSale = ({
    emptyMessage = "",
    tableColumns,
    data,
    setData,
    selectedData,
    setSelectedData,
    loading = true,
    dataKey,
    actionButton,
    dialog,
    isColor,
    actionButtonWidth = 1,
    body,
    autoLayout = true,
    actionHeader,
    sticky,
    width,
    type,
    ...rest
}) => {
    /**@emptyMessage => if no data found message */
    /**@tableColumns => tableColumns you want*/
    /**@data / @setData => state for table data*/
    /**@loading / @setLoading => loading state=> true / false*/
    /** @selectedData / @setSelectedData => state for selected data */
    /** @showModal / @setShowModal => state for modal */
    /** @dataKey => unique id of the field */
    /** @actionButton => Action button of the field */
    /** @dialog => method for dialog box*/

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (typeof data === "undefined" || data === null) {
            return setTableData([]);
        }
        setTableData(data);
    }, [data]);

    const price = (data) => {
        let total_price = 0
        if(type==='sale'){
            for (let i=0; i < data.length; i ++){
                if(data[i].item?.saleable_rate){
                    total_price = total_price + (data[i]?.sale_quantity * parseFloat(data[i].item?.saleable_rate)) || 0
                }
            }
        }
        return total_price
    }


    return (
        <div className={`p-grid table table2 ${sticky && "sticky"}`}>
            <div className="p-col-12">
                <div className="card">
                    <DataTable
                        className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers "
                        value={data}
                        dataKey={dataKey}
                        rowHover
                        selection={selectedData}
                        onSelectionChange={(e) => setSelectedData?.(e.value)}
                        emptyMessage={emptyMessage}
                        loading={loading}
                        header={null}
                        resizableColumns
                        columnResizeMode="expand"
                        showGridlines
                        stripedRows
                        // autoLayout={autoLayout}
                        // responsiveLayout="scroll"
                        selectionMode="checkbox"
                        selectionAutoFocus={false}
                        tableStyle={{fontSize: '1.3rem'}}
                        {...rest}
                    >
                        {tableColumns?.map((col, i) => (
                            <Column key={i} field={col.field} header={col.header} body={col.sortableBody} style={{ minWidth: col.minWidth, width: '45%' }} onRowClick={null}></Column>
                        ))}
                        {actionButton && <Column body={actionButton} header={actionHeader || "Action"} headerStyle={{ textAlign: "center", width: `${actionButtonWidth}rem` }}></Column>}
                    </DataTable>
                    <div className="grid">
                        <div className="col-12 md:col-9" style={{"textAlign": "center", "padding": "0px", "marginTop": "30px", "color": "#ab0dab", "fontWeight": "bold", "fontSize": "1.5rem"}}>
                            <span>Total Price: </span>
                        </div>
                        <div className="col-12 md:col-1" style={{"textAlign": "center", "padding": "0px", "marginTop": "30px", "color": "#ab0dab", "fontWeight": "bold", "fontSize": "1.5rem"}}>
                            <span style={{"marginLeft": "77px"}}>
                                {parseFloat(price(tableData)).toLocaleString('en-US')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
